import { Box, Button, formLabelClasses, Modal } from '@mui/material'
import React, { useState } from 'react'
import PaymentCardImage from '../assets/imgs/profile-screen-images/payment-card-image.png'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import AddPaymentCardModal from './AddPaymentCardModal'
import RedemptionsModal from './RedemptionsModal'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const PaymentModal = ({
  handlePaymentModal,
  togglePaymentModal = formLabelClasses,
}) => {
  const [toggleAddPaymentCardModal, setToggleAddPaymentCardModal] = useState(
    false,
  )
  const [toggleRedemptionsModal, setToggleRedemptionsModal] = useState(false)

  const handleAddPaymentCardModal = () => {
    if (togglePaymentModal) {
      handlePaymentModal(false)
    }
    setToggleAddPaymentCardModal(!toggleAddPaymentCardModal)
  }
  const handleRedemptionsModal = () => {
    if (togglePaymentModal) {
      handlePaymentModal(false)
    }
    setToggleRedemptionsModal(!toggleRedemptionsModal)
  }

  return (
    <div>
      <Modal
        open={togglePaymentModal}
        onClose={() => handlePaymentModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="support-modal">
          <div>
            <h3 className="fs-24 mb-3">Payment</h3>
            <img src={PaymentCardImage} alt="Payment Card Image" />
            <div className="mb-5 mt-3">
              <div
                className="d-flex justify-content-between align-items-center px-1 py-2 pointer"
                onClick={handleAddPaymentCardModal}
              >
                <p className="fs-16 m-0">Add Card</p>
                <ChevronRightIcon />
              </div>
              <div
                className="d-flex justify-content-between align-items-center px-1 py-2 pointer"
                onClick={handleRedemptionsModal}
              >
                <p className="fs-16 m-0">Redemptions</p>
                <ChevronRightIcon />
              </div>
            </div>
            <Button
              fullWidth
              disableElevation
              id="btn-primary-no-shadow"
              className="pointer mt-5"
              onClick={() => handlePaymentModal(false)}
            >
              Continue
            </Button>
          </div>
        </Box>
      </Modal>
        <AddPaymentCardModal
          handleAddPaymentCardModal={handleAddPaymentCardModal}
          addPaymentCardModal={toggleAddPaymentCardModal}
        />
        <RedemptionsModal
          handleRedemptionsModal={handleRedemptionsModal}
          toggleRedemptionsModal={toggleRedemptionsModal}
        />
    </div>
  )
}

export default PaymentModal
